import i18next from "i18next";
import XHR from "i18next-xhr-backend";
import emp_en from "../translations/en";
import emp_en_AUS from "../translations/en_AUS";
import emp_en_NZL from "../translations/en_NZL";
import emp_en_PHL from "../translations/en_PHL";
import emp_en_ZAF from "../translations/en_ZAF";
import emp_en_THA from "../translations/en_THA";
import emp_th_THA from "../translations/th_THA";
import emp_vi_VNM from "../translations/vi_VNM";
import TranslationsClient from "../components/translations/TranslationsClient.js";
import { isLikelyJwt } from "../auth/tokenShape";

let failedLoadingHandlerAttached = false;

const i18n = (token = null) => {
  if (i18next.isInitialized) {
    return i18next;
  }

  const language = i18next.language || "en_AUS";

  const languageUrl = TranslationsClient.getDefaultLanguage();

  const backendOptions = {
    type: "backend",
    crossDomain: false,
    allowMultiLoading: false,
    loadPath: languageUrl + "{{lng}}",
    customHeaders: isLikelyJwt(token)
      ? { authorization: `Bearer ${token}` }
      : {},
  };

  const options = {
    initImmediate: false,
    debug: true,
    lng: language,
    fallbackLng: language,
    ns: ["emp"],
    defaultNS: "emp",
    react: {
      wait: true,
      bindI18n: "languageChanged loaded",
      bindStore: "added removed",
      nsMode: "default",
      defaultTransParent: "div",
    },
  };

  const resources = {
    en: { emp: emp_en },
    en_AUS: { emp: emp_en_AUS },
    en_NZL: { emp: emp_en_NZL },
    en_PHL: { emp: emp_en_PHL },
    en_ZAF: { emp: emp_en_ZAF },
    en_THA: { emp: emp_en_THA },
    th_THA: { emp: emp_th_THA },
    vi_VNM: { emp: emp_vi_VNM },
  };

  // Bundled resources are loaded into the i18next store at init time.
  // i18next won't call the XHR backend for any language already present here.
  options["resources"] = resources;

  options["backend"] = backendOptions;

  // eslint-disable-next-line import/no-named-as-default-member
  i18next.use(XHR).init(options);

  // Loading translations from local shared folder if translation service fails
  if (!failedLoadingHandlerAttached) {
    i18next.on("failedLoading", function (lng, ns) {
      const safeLanguage = typeof lng === "string" ? lng : "";
      // Check the full locale first (e.g. "en_AUS"), then fall back to the
      // 2-char base language (e.g. "en") for any unrecognised variant.
      const resourceLng = resources[safeLanguage]
        ? safeLanguage
        : safeLanguage.slice(0, 2);

      const fallbackNamespace = resources[resourceLng]?.[ns] ? ns : "emp";

      if (resources[resourceLng]?.[fallbackNamespace]) {
        i18next.addResourceBundle(
          lng,
          fallbackNamespace,
          resources[resourceLng][fallbackNamespace],
          false,
          true
        );
      }
    });
    failedLoadingHandlerAttached = true;
  }

  return i18next;
};

export default i18n;
